import { Grid } from "@mui/material";
import React from "react";

const TopWinning = (props) => {
    return(
        <Grid 
            container
            xs={12}
            alignItems="center"
            className="MS---top--winning my-3"
        >
            <Grid
                xs={2}
            > 
                <p className="icon">{props.position}</p>
            </Grid>
            <Grid
                xs={7}
                className="pl-2"
            >
                <p className="mb-0" style={{fontSize: 15}}>{props.address}</p>
                <span style={{fontSize: 15,color: '#ffffff80'}}>{props.duration}</span>
            </Grid>
            <Grid
                xs={3}
            >
                <p className="mb-0" style={{fontSize: 15}}>{props.amount} MSF</p>
            </Grid>
        </Grid>
    );
}

export default TopWinning;